import { render, staticRenderFns } from "./TurnSelect.vue?vue&type=template&id=279b3a4c&scoped=true&"
import script from "./TurnSelect.vue?vue&type=script&lang=ts&"
export * from "./TurnSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279b3a4c",
  null
  
)

export default component.exports